import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-quizz="container"]'
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initAccordions()
    }

    function initAccordions() {

        function allAnswered() {
            var allHaveActive = true;

            $('.answer-boxes-second').each(function() {
                if ($(this).find('.single-box.active').length === 0) {
                allHaveActive = false;
                return false; // stop loop early
                }
            });

            return allHaveActive;
        }
        
        $('.answer-boxes-second .single-box').on('click', function () {
            // $(this).parent().find('.single-box').removeClass('active');
            // $(this).addClass('active');
            $(this).addClass('active').siblings().removeClass('active');
            if (allAnswered()) {
                $('#submit-btn').slideDown();
            }
        })

        $('.show-results').on('click', function () {
            $('.results-wrap').slideDown();
        })
    }

    return Object.freeze({
        init,
    })
}